import styled from 'styled-components';
import { Tooltip, Box } from '@mui/material';

export const Title = styled.p`
  font-weight: bold;
  margin-bottom: 16px;
`;

export const TooltipIcon = styled(Tooltip)`
  color: #ccc;
  margin-left: 4px;
`;

export const TooltipWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: flex-start;
`;
